import action from 'app/lib/action';
import {STORE_UNIT} from '../constants/actionTypes';

export default {
    request : (formData) => action(STORE_UNIT.REQUEST)({formData}),
    success : (unit, vtrac) => action(STORE_UNIT.SUCCESS)({unit, vtrac}),
    error   : (error) => action(STORE_UNIT.ERROR)({error})
};